<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <ul slot-scope="{ row, index }" slot="shippingAddressList">
        <li v-for="(x, index) in row.shippingAddressList" :key="index">
          {{ x.address }}
        </li>
      </ul>
      <ul slot-scope="{ row, index }" slot="pickupAddressList">
        <li v-for="(x, index) in row.pickupAddressList" :key="index">
          {{ x.address }}
        </li>
      </ul>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      ref="formModel"
      :labelWidth="100"
      width="700"
    >
      <addressList
        slot="shippingAddressList"
        v-model="item.shippingAddressList"
      >
      </addressList>
      <addressList slot="pickupAddressList" v-model="item.pickupAddressList">
      </addressList>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import addressList from "./addressList.vue";
export default {
  components: { addressList },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        types: "中港",
        settleType:'',
        name: "", //数据名称
        contact: "",
        manager: "",
        tel: "",
        fax: "",
        mobile: "",
        address: "",
        shippingAddressList: [],
        pickupAddressList: [],
        creditCode: "",
        saleman: "",
        salemanId: "",
        ticket: "",
        remark: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      categorys: [],
      forms: [
        {
          title: "数据名称",
          key: "name",
          type: "Input",
          required: true,
          span: 12,
        },
        {
          title: "分类",
          key: "types",
          type: "Select",
          selectItems:['中港','非中港'],
          required: true,
        },
        {
          title: "结算方式",
          key: "settleType",
          type: "Select",
          selectItems: ["月结", "现结", "单结", "其他"],
          required: true,
        },
        {
          title: "负责人",
          key: "manager",
          type: "Input",
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
        },
        {
          title: "地址",
          key: "address",
          type: "selectAddMap",
        },
        /* {
          title: "进货地址",
          key: "shippingAddressList",
          slot: "shippingAddressList",
          slotForm: "shippingAddressList",
        },
        {
          title: "提货地址",
          key: "pickupAddressList",
          slot: "pickupAddressList",
          slotForm: "pickupAddressList",
        }, */

        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
    };
  },
  methods: {
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/supplier/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/supplier/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/supplier/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-base/supplier/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory

    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/wuliugongyingshangguanli.vue